import { cn } from "@/lib/utils";

interface AnswerRecapProps {
  value: string;
  className?: string;
}

/**
 * Neutral recap of the learner's submitted answer — used after grading so the
 * verdict stays on GradedFeedback, not on a second colored answer surface.
 */
const AnswerRecap = ({ value, className }: AnswerRecapProps) => (
  <div
    className={cn(
      "w-full rounded-lg border-2 border-primary/20 bg-muted/40 px-4 py-3 space-y-1",
      className
    )}
  >
    <p className="font-semibold uppercase tracking-wide text-muted-foreground">
      Deine Antwort
    </p>
    <p className="whitespace-pre-wrap text-foreground">„{value}“</p>
  </div>
);

export default AnswerRecap;
